/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';

/**
 *
 * @export
 * @interface ConversationalAgentInferencerCelina
 */
export interface ConversationalAgentInferencerCelina {
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentInferencerCelina
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCelina
   */
  name?: string | null;
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof ConversationalAgentInferencerCelina
   */
  protocol: ConversationalAgentProtocolEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof ConversationalAgentInferencerCelina
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof ConversationalAgentInferencerCelina
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCelina
   */
  environment: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCelina
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCelina
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerCelina
   */
  domain?: string;
}

/**
 * Check if a given object implements the ConversationalAgentInferencerCelina interface.
 */
export function instanceOfConversationalAgentInferencerCelina(
  value: object,
): value is ConversationalAgentInferencerCelina {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('environment' in value) || value['environment'] === undefined) return false;
  if (!('tenant' in value) || value['tenant'] === undefined) return false;
  return true;
}

export function ConversationalAgentInferencerCelinaFromJSON(json: any): ConversationalAgentInferencerCelina {
  return ConversationalAgentInferencerCelinaFromJSONTyped(json, false);
}

export function ConversationalAgentInferencerCelinaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerCelina {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    protocol: ConversationalAgentProtocolEnumFromJSON(json['protocol']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    environment: json['environment'],
    tenant: json['tenant'],
    region: json['region'] == null ? undefined : json['region'],
    domain: json['domain'] == null ? undefined : json['domain'],
  };
}

export function ConversationalAgentInferencerCelinaToJSON(
  value?: Omit<ConversationalAgentInferencerCelina, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    environment: value['environment'],
    tenant: value['tenant'],
    region: value['region'],
    domain: value['domain'],
  };
}
